<template>
  <div>
  <v-row no-gutters>
    <v-col v-for="n in repeat" :key="n" :class="{'col-lg-5 col-md-6' : isBucket}">
      <div class="seat-wrap">
        <img class="preview" :src="baseSeat" />
        <img class="preview overlay" :src="insertOverlay" v-if="seat.insert" />
        <img class="preview overlay" :src="diamondQuilt" v-if="dq" />
        <img class="preview overlay" :src="trimOverlay" v-if="seat.trim" />
      </div>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <p class="caption">Images above are for reference only and may not reflect your quilting choice.</p>
    </v-col>
  </v-row>
  </div>
</template>

<style scoped lang="scss">
.preview {
  max-width: 100%;
  height: 100%;
  object-fit: contain;

  @media screen and (min-width: 1264px) {
    max-height: 20rem;
    max-width: 500px;
  }
}

.seat-wrap {
  position: relative;
  display: flex;
  width: 100%;
  height: 310px;

  &:first-of-type {
    margin-top: 0;

    @media screen and (min-width: 600px) {
      margin-top: 40px;
    }
  }
}
.overlay {
  position: absolute; top: 0; left: 0
}
</style>

<script>
import { getBaseSeat, getOverlay, getDiamondQuilt } from '@/services/assets'
import { getDiamondQuiltOption } from '@/utils'

export default {
  props: {
    seat: Object,
  },
  computed: {
    repeat: function() {
      return this.seat.ssSeatTypeCode === 'bucket' ? 2 : 1
    },
    baseSeat: function() {
      return getBaseSeat(this.seat)
    },
    isBucket: function() {
      return this.seat.ssSeatTypeCode === 'bucket'
    },
    insertOverlay: function() {
      return getOverlay(this.seat, 'insert')
    },
    trimOverlay: function() {
      return getOverlay(this.seat, 'trim')
    },
    dq: function() {
      return getDiamondQuiltOption(this.seat)?.added
    },
    diamondQuilt: function() {
      return getDiamondQuilt(this.seat)
    },
  }
}
</script>
